import DetailFormHead from "components/subHead/detailFormHead";
import { useGetData } from "./service";
import { useTranslation } from "react-i18next";
import LodInfRow from "components/rows/lodRow";
import TableRow from "components/rows/tableRow";
import Cell from "components/rows/cell";
import { dateFormat, priceFormat } from "components/utils/comm";
import BaseInfLoaing from "components/detailLoading/baseInf";

export default function RoomCancelResvDetail() {
  const { t } = useTranslation();
  const { rmResvCnlDtl, isLoading, isSuccess } = useGetData();

  // 투숙객 이름
  // 취소 사유

  return (
    <>
      <>
        {/* 기본정보 */}
        <DetailFormHead title={t("row_ttl_default")} />
        {(!rmResvCnlDtl || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
        )}
        {rmResvCnlDtl && (
          <table>
            <tbody>
              <LodInfRow />
              <TableRow title={t("row_ttl_rm_inf")}>
                <ul>
                  <li>
                    <Cell label={t("lbl_rm_nm")} value={rmResvCnlDtl?.rmNm} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rm_typ")}
                      value={rmResvCnlDtl?.rmTypNm}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rm_olk")}
                      value={rmResvCnlDtl?.rmOlkNm}
                    />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}

        {/* 상품정보 */}
        <DetailFormHead title={t("row_ttl_rm_pd")} />
        {(!rmResvCnlDtl || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
        )}
        {rmResvCnlDtl && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_rmpd")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_no")}
                      value={rmResvCnlDtl?.rmPdNo}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_dt")}
                      value={dateFormat(rmResvCnlDtl?.sellDt, "-")}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_price")}
                      value={priceFormat({
                        price: rmResvCnlDtl?.rmSellPri,
                      })}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_chl")}
                      value={rmResvCnlDtl?.lodChlNm}
                    />
                  </li>

                  <li>
                    <Cell label={t("lbl_prom_cd")} value={"--"} />
                  </li>
                  <li>
                    <Cell label={t("lbl_prom_nm")} value={"--"} />
                  </li>
                  <li>
                    <Cell label={t("lbl_prom_price")} value={"--"} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}

        {/* 예약정보 */}
        <DetailFormHead title={t("row_ttl_resv")} />
        {(!rmResvCnlDtl || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
        )}
        {rmResvCnlDtl && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_resv")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_resv_no")}
                      labelFor="bold"
                      value={rmResvCnlDtl?.rmResvNo}
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_resv_sequence")} value={""} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_amt")}
                      value={priceFormat({
                        price: rmResvCnlDtl?.payAmt,
                      })}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_check_in_dt")}
                      value={dateFormat(rmResvCnlDtl?.resvSDt)}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_check_out_dt")}
                      value={dateFormat(rmResvCnlDtl?.resvEDt)}
                    />
                  </li>

                  <li>
                    <Cell
                      label={t("lbl_resv_dt")}
                      value={dateFormat(rmResvCnlDtl?.resvDtti.slice(0, 8))}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_cnl_dt")}
                      labelFor="bold"
                      value={dateFormat(rmResvCnlDtl?.cnlDtti.slice(0, 8))}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_day_ct")}
                      value={rmResvCnlDtl?.resvDayCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_rm_ct")}
                      value={rmResvCnlDtl?.resvRmCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_per_ct")}
                      value={rmResvCnlDtl?.resvPerCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_adlt_per_ct")}
                      value={rmResvCnlDtl?.adltPerCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_chld_per_ct")}
                      value={rmResvCnlDtl?.chldPerCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_baby_per_ct")}
                      value={rmResvCnlDtl?.babyPerCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_eml_dtti")}
                      value={dateFormat(
                        rmResvCnlDtl?.resvDtti.slice(0, 8),
                        "-"
                      )}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_resv_fax_dtti")}
                      value={dateFormat(
                        rmResvCnlDtl?.resvDtti.slice(0, 8),
                        "-"
                      )}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_mem_nm")}
                      value={
                        (rmResvCnlDtl?.memSurnm ?? "") +
                          (rmResvCnlDtl?.memFstnm ?? "") || "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_mem_phone_no")}
                      value={rmResvCnlDtl?.memMblNo ?? "--"}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cst_nm")}
                      value={
                        (rmResvCnlDtl?.resvCstSurnm ?? "") +
                        (rmResvCnlDtl?.resvCstFstnm ?? "")
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cst_phone")}
                      value={rmResvCnlDtl?.resvCstMblNo}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cst_eml")}
                      value={rmResvCnlDtl?.resvCstEml}
                    />
                  </li>
                  <li className="w-full">
                    <Cell
                      label={t("lbl_req_cn")}
                      value={rmResvCnlDtl?.reqCn ?? "-"}
                    />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}

        {/* 결제정보 */}
        <DetailFormHead title={t("sub_ttl_pay_cnl")} />
        {(!rmResvCnlDtl || isLoading) && (
          <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
        )}
        {rmResvCnlDtl && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_pay_cnl")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_resv_cnl_dt")}
                      value={
                        dateFormat(rmResvCnlDtl?.cnlDtti.slice(0, 8)) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cnl_rg_seq")}
                      value={rmResvCnlDtl?.cnlRgSeq}
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_resv_rg_seq_old")} value={"--"} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_ref_cd")}
                      value={rmResvCnlDtl?.refAuthCode}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_ref_trand_id")}
                      value={rmResvCnlDtl?.refTranId}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_trand_id")}
                      value={rmResvCnlDtl?.tranId}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_ref_typ")}
                      value={
                        rmResvCnlDtl?.refTyp === "P"
                          ? t("lbl_cnl_partial")
                          : rmResvCnlDtl?.refTyp === "T"
                          ? t("lbl_cnl_full")
                          : "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_amt")}
                      labelFor="bold"
                      value={
                        priceFormat({ price: rmResvCnlDtl?.payAmt }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cnl_fee_amt")}
                      labelFor="bold"
                      value={
                        priceFormat({ price: rmResvCnlDtl?.cnlFeeAmt }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_ref_amt")}
                      labelFor="bold"
                      value={
                        priceFormat({ price: rmResvCnlDtl?.refAmt }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_un_pay_amt")}
                      labelFor="bold"
                      value={
                        priceFormat({ price: rmResvCnlDtl?.balAmt }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_method")}
                      value={rmResvCnlDtl?.payMethodNm}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_crr_cmm")}
                      value={rmResvCnlDtl?.currCd ?? "--"}
                    />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}
      </>
    </>
  );
}
